import React, { Component } from 'react';

class Carousel extends Component {
    constructor(props){
        super(props);

        this.switchImage = this.switchImage.bind(this);
        
        this.state = {selected:0}

        this.active = 0;
        this.images = [
            "https://s3.amazonaws.com/images.disconnect.me/images/offers/marketing-image-1.jpg",
            "https://s3.amazonaws.com/images.disconnect.me/images/offers/marketing-image-2.jpg",
            "https://s3.amazonaws.com/images.disconnect.me/images/offers/marketing-image-3.jpg",
            "https://s3.amazonaws.com/images.disconnect.me/images/offers/marketing-image-4.jpg",
            "https://s3.amazonaws.com/images.disconnect.me/images/offers/marketing-image-5.jpg"
        ]

        
    }

    switchImage(n){
        this.setState({selected:n})
    }

    
    
    render() {
        var mainImages = this.images.map((item,i) => {
            return <img src={item} key={i} alt="Disconnect Premium"/>
        })

        var controls = this.images.map((item,i) => {
            var cl = i === this.state.selected ? "inline-block border active" : "inline-block border";
            return (
                <a className={cl} key={i}>
                    <img src={item} onClick={() => {this.switchImage(i)}} alt="Disconnect Premium"/>
                </a>
            )
        })
        
        var left = this.state.selected * -100 + "%"
        
        return (
            <div className="sm-col sm-col-12 md-col-8 pb2 mt2 px1">
                <div className="carousel">
                    <figure style={{"left":left}}>
                        {mainImages}
                    </figure>
                </div>
                <div className="carousel-ctrl">
                    {controls}
                </div>
            </div>
        )
    }
}

export default Carousel


// WEBPACK FOOTER //
// ./src/carousel/index.js